import { useGameStore } from "../../store/gameStore";

const RESOURCES = [
  { key: "wood",    icon: "\u{1FAB5}", label: "Wood",    color: "#6B4226" },
  { key: "wine",    icon: "\u{1F377}", label: "Wine",    color: "#722F37" },
  { key: "marble",  icon: "\u2B1C",    label: "Marble",  color: "#8A8478" },
  { key: "crystal", icon: "\u{1F48E}", label: "Crystal", color: "#1E5F8A" },
  { key: "sulfur",  icon: "\u{1F525}", label: "Sulfur",  color: "#C45B3A" },
  { key: "gold",    icon: "\u{1FA99}", label: "Gold",    color: "#A68B42" },
] as const;

export function ResourceBar() {
  const cities = useGameStore((s) => s.cities);
  const activeCityId = useGameStore((s) => s.activeCityId);
  const user = useGameStore((s) => s.user);
  const city = cities.find((c) => c.id === activeCityId);

  if (!city) return null;

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "2px",
      padding: "6px 10px",
      background: "linear-gradient(180deg, var(--parchment) 0%, var(--papyrus-dark) 100%)",
      borderBottom: "1.5px solid var(--sand)",
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
      msOverflowStyle: "none",
      scrollbarWidth: "none",
      minHeight: "var(--resource-bar-height)",
      flexShrink: 0,
    }}>
      {RESOURCES.map((r) => {
        const val = r.key === "gold" ? (user?.gold ?? 0) : city[r.key as keyof typeof city] as number;
        return (
          <div key={r.key} style={{
            display: "flex",
            alignItems: "center",
            gap: "3px",
            padding: "3px 6px",
            borderRadius: "6px",
            background: "rgba(255,255,255,0.4)",
            minWidth: "fit-content",
            flex: "1 0 auto",
          }}>
            <span style={{ fontSize: "0.85rem", lineHeight: 1 }}>{r.icon}</span>
            <span style={{
              fontSize: "0.75rem",
              fontWeight: 700,
              color: r.color,
              fontVariantNumeric: "tabular-nums",
              fontFamily: "var(--font-body)",
            }}>
              {formatNumber(val)}
            </span>
          </div>
        );
      })}
    </div>
  );
}

function formatNumber(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 10_000) return (n / 1_000).toFixed(1) + "K";
  return Math.floor(n).toLocaleString();
}
